import { Button, Grid } from "@pushpress/shared-components";

type ActionItemType = {
  description: string;
  url: string;
  urlDescription: string;
};

export default function ActionItem({
  description,
  url,
  urlDescription,
}: ActionItemType) {
  return (
    <Grid paddingX={1} container item alignItems="center">
      <Grid item marginX={1}>
        {description}
      </Grid>
      <Grid item>
        <Button
          data-testid="ActionItemButton"
          text={urlDescription}
          buttonType="text"
          href={url}
          target="_blank"
        />
      </Grid>
    </Grid>
  );
}
